<script>
  import { userManager } from "@/utility/zitadelLoginModule";

  export default {
    name: "ZitadelCallback",
    data() {
      return {
        userManager: userManager,
      };
    },
    async mounted() {
      await this.callbackFn();
    },
    methods: {
      async callbackFn() {
        try {
          await userManager.signinPopupCallback();
        } catch (error) {
          console.error(error);
          window.close();
        }
      },
    },
  };
</script>
